import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SmoothCollapse from 'react-smooth-collapse';
import ChevronDownIcon from 'calcite-ui-icons-react/ChevronDownIcon';

import MapController from '../../../../controllers/MapController';

import { RootState } from '../../../../reducers/app';

import './my-layer.scss';
import LayerTooltip from './layer-tooltip';
import InfoSvg from '../../../../assets/info-icon';
import TerrainLegend from '../../../../assets/terrain-legend.png';

const TerrainLayer = ({ layer }: { layer: any }) => {
  // LOCAL STATE
  const [sectionOpen, setSectionOpen] = useState<boolean>(false);

  // REDUX
  const visibleLayers = useSelector((state: RootState) => state.mapview.visibleLayers);

  // REFS

  return (
    <div className='layer-container' key={layer.id}>
      <div className='layer'>
        <div className='layer-title__wrapper'>
          <input
            type='checkbox'
            id={layer.id}
            name={layer.id}
            checked={visibleLayers.includes(layer.id)}
            onChange={() => MapController.updateLayerVisibility(layer.id, !visibleLayers.includes(layer.id))}
          />
          <div className='layer-title'>{layer.title}</div>
        </div>
        <div className='tools'>
          {layer.description && layer.description.length > 0 && (
            <LayerTooltip tip={layer.description}>
              <InfoSvg />
            </LayerTooltip>
          )}
          <ChevronDownIcon
            className={sectionOpen ? 'open' : ''}
            size={24}
            onClick={() => setSectionOpen(!sectionOpen)}
          />
        </div>
      </div>
      <SmoothCollapse className='hansen-container' expanded={sectionOpen} allowOverflowWhenOpen eagerRender={true}>
        <img className='terrain-legend' src={TerrainLegend} alt='Terrain Layer Legend' />
      </SmoothCollapse>
    </div>
  );
};

export default TerrainLayer;
